<template>
  <!-- 红宝书社交课程 -->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo16" :type="'hbs-a'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo16 from '@/assets/images/logo16.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo16
    }
  }
}
</script>